import { ChartOptions } from 'chart.js';
import { TransactionsSuccessSummary } from 'types/embedded/dashboard';

export function useDashboardTransactionsSummaryChartOptions(
  summary?: TransactionsSuccessSummary,
): ChartOptions<'doughnut'> {
  const percentages = [
    summary?.successful.percentage,
    summary?.refused.percentage,
    summary?.pending.percentage,
  ];

  return {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        color: '#000',
        font: {
          weight: 'bold',
          size: 14,
        },
        formatter: (_, context) => {
          const percentage = percentages[context.dataIndex] || 0;

          return `${percentage}%`;
        },
      },
      legend: {
        labels: {
          boxWidth: 16,
          boxHeight: 16,
        },
      },
      tooltip: {
        enabled: false,
      },
    },
  };
}
